import { memo, useCallback } from 'react'
import PropTypes from 'prop-types'

import Column from './Column'
import ColumnsAdder from './ColumnsAdder'

import './NcsvColumns.scss'

const EMPTY_ARRAY = []

const NcsvColumns = ({ index, mandatoryColumns = EMPTY_ARRAY, onChange, optionalColumns = EMPTY_ARRAY }) => {
  const onChangeLocal = useCallback((value, { name }) => onChange(value, { name, index }), [onChange, index]),
        onAddMandatoryColumn = useCallback(() => onChangeLocal(mandatoryColumns.add({ values: [""], name: "" }), { name: "mandatoryColumns" }), [mandatoryColumns, onChangeLocal]),
        onAddOptionalColumn = useCallback(() => onChangeLocal(optionalColumns.add({ values: [""], name: "" }), { name: "optionalColumns" }), [onChangeLocal, optionalColumns])

  return (
    <div className="data-lake__group-dialog__advanced__ncsv-columns">
      <ColumnsAdder
          label="Required columns"
          onAdd={onAddMandatoryColumn}
      />
      {mandatoryColumns.map(({ name, values }, columnIndex) => (
        <Column
            columns={mandatoryColumns}
            columnsName="mandatoryColumns"
            index={columnIndex}
            key={`mandatory ${columnIndex}`}
            name={name}
            onChange={onChangeLocal}
            values={values}
        />
      ))}
      <ColumnsAdder
          label="Optional columns"
          onAdd={onAddOptionalColumn}
      />
      {optionalColumns.map(({ name, values }, columnIndex) => (
        <Column
            columns={optionalColumns}
            columnsName="optionalColumns"
            index={columnIndex}
            key={`optional ${columnIndex}`}
            name={name}
            onChange={onChangeLocal}
            values={values}
        />
      ))}
    </div>
  )
}

NcsvColumns.propTypes = {
  index: PropTypes.number.isRequired,
  mandatoryColumns: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  optionalColumns: PropTypes.array
}

export default memo(NcsvColumns)
